import { Line } from "react-chartjs-2";
import {
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Tooltip,
} from "chart.js";
import { useEffect, useState } from "react";
import { getServiciosPorAseguradoraAnual } from "./serviceLizen";
import { BACKGROUND_COLOR_PLUGIN } from "./../shared/utils";
import TituloYDescarga from "../shared/components/TituloYDescarga";
import { Menu, MenuItem } from "semantic-ui-react";

ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Legend,
  Tooltip
);

const ServicioLizenConvenioAnual = () => {
  const CHART_ID = "servicios_lizen_convenio_anio";
  const CHART_TITLE = "Cantidad de servicios por convenio anual";
  const [dataSet, setDataSet] = useState(null);
  const [activeItem, setActiveItem] = useState(new Date().getFullYear());
  const handleItemClick = (e, { name }) => setActiveItem(name);

  useEffect(() => {
    async function fetchData() {
      const data = await getServiciosPorAseguradoraAnual(activeItem);
      setDataSet(data);
    }
    fetchData();
  }, [activeItem]);

  const getAniosDisponibles = () => {
    const anioActual = new Date().getFullYear();
    const anios = [];
    for (let i = 0; i < 5; i++) {
      if (anioActual - i >= 2022) {
        anios.push(anioActual - i);
      } else {
        break;
      }
    }
    return anios;
  };

  const options = {
    plugins: {
      legend: true,
    },
  };

  return (
    <>
      <TituloYDescarga
        titulo={CHART_TITLE}
        idsCharts={[CHART_ID]}
        chartsNames={[CHART_ID]}
      />
      <Menu attached="top" tabular>
        {getAniosDisponibles().map((anio) => (
          <MenuItem
            name={anio}
            active={activeItem === anio}
            onClick={handleItemClick}
          />
        ))}
      </Menu>{" "}
      {dataSet ? (
        <Line
          id={CHART_ID}
          plugins={[BACKGROUND_COLOR_PLUGIN]}
          data={dataSet}
          height={50}
          options={options}
        ></Line>
      ) : (
        <div>Cargando...</div>
      )}
    </>
  );
};

export default ServicioLizenConvenioAnual;
